import React, { Fragment } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Label, ColorPicker, Error } from 'shared/ui'
import { useRcsCreateContext } from 'pages/settings/pages/rcs/context/rcsCreateContext'
import { ImageUploaderInput } from './ImageUploaderInput'

export const BrandLogoSection: React.FC = observer(() => {
  const {
    profileStore: {
      accentColor,
      setAccentColor,
      setLogoFile,
      logoError,
      logoLoading,
      logoUrl,
      hasLogoUrl,
      logoSubtitle,
      removeLogo,
      setBannerFile,
      bannerUrl,
      hasBannerUrl,
      bannerSubtitle,
      bannerError,
      bannerLoading,
      removeBanner,
      accentColorError,
    },
  } = useRcsCreateContext()

  return (
    <Fragment>
      <Box mt={'34px'} mb={'36px'}>
        <ImageUploaderInput
          setFile={setLogoFile}
          url={logoUrl}
          hasUrl={hasLogoUrl}
          label='Logo'
          subtitle={logoSubtitle}
          loading={logoLoading}
          remove={removeLogo}
          error={logoError}
          tooltipProps={{
            label: (
              <>
                Your logo will be cropped into a circle.
                <br />
                Only PNG and JPG formats are supported.
                <br />
                The border won’t overlap the logo. Avoid
                <br />
                images with transparencies.
              </>
            ),
          }}
        />
      </Box>
      <Box
        display={'flex'}
        justifyContent={'center'}
        width={'100%'}
        flexDirection={'column'}
        gap={'20px'}
      >
        <Box mt={'4px'} mb={'40px'}>
          <ImageUploaderInput
            setFile={setBannerFile}
            url={bannerUrl}
            hasUrl={hasBannerUrl}
            label='Banner image'
            subtitle={bannerSubtitle}
            loading={bannerLoading}
            remove={removeBanner}
            error={bannerError}
            isSquare
            tooltipProps={{
              label: <>Only PNG and JPG formats are supported</>,
            }}
          />
        </Box>
      </Box>
      <Box
        display={'flex'}
        justifyContent={'center'}
        width={'100%'}
        flexDirection={'column'}
        mb={'40px'}
      >
        <Box mb={'4px'}>
          <Label
            label={{
              text: 'Accent color',
              textColor: 'var(--content-primary-primary)',
              horizontal: true,
            }}
            questionTooltipProps={{
              label: (
                <>
                  Used for button borders and highlights to
                  <br />
                  enhance your sender profile. The accent
                  <br />
                  color must have a contrast ratio of at least
                  <br />
                  4.5:1 against white.
                </>
              ),
              placement: 'top',
            }}
          />
        </Box>
        <ColorPicker color={accentColor} setColor={setAccentColor} />
        {accentColorError && (
          <Box mt={'4px'}>
            <Error type='text' error={accentColorError} />
          </Box>
        )}
      </Box>
    </Fragment>
  )
})
